import Header from './partials/Header'

const MasterLayout = ({ children }) => {
  return (
    <>
      <div id="master-layout" className="bg-brandPrimary w-[100vw] h-[100vh] relative flex flex-col overflow-y-scroll">
        <Header />
        {children}
      </div>
      <div className="_landscape text-center bg-brandPrimary w-[100vw] h-[100vh]">
        <h1 className="_center-center">Please rotate your device for the best experience.</h1>
      </div>
    </>
  )
}

export default MasterLayout
